function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _ApprovalRequestStatus;
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// TODO: move api value mapping to mapper file(s)
export var ApprovalRequestStatusState = /*#__PURE__*/function (ApprovalRequestStatusState) {
  ApprovalRequestStatusState["Pending"] = "pending";
  ApprovalRequestStatusState["Approved"] = "approved";
  ApprovalRequestStatusState["Rejected"] = "rejected";
  ApprovalRequestStatusState["None"] = "NONE";
  return ApprovalRequestStatusState;
}({});
export function state(pending, approved, rejected) {
  if (rejected) {
    return ApprovalRequestStatusState.Rejected;
  }
  if (pending) {
    return ApprovalRequestStatusState.Pending;
  }
  if (approved) {
    return ApprovalRequestStatusState.Approved;
  }
  return ApprovalRequestStatusState.None;
}
var ApprovalRequestStatus = /*#__PURE__*/function () {
  function ApprovalRequestStatus(pendingCount, approvedCount, rejectedCount) {
    _classCallCheck(this, ApprovalRequestStatus);
    this.pendingCount = pendingCount;
    this.approvedCount = approvedCount;
    this.rejectedCount = rejectedCount;
    this.state = void 0;
    this.state = state(pendingCount, approvedCount, rejectedCount);
  }
  return _createClass(ApprovalRequestStatus, null, [{
    key: "changed",
    value: function changed(a, b) {
      return a.approvedCount !== b.approvedCount || a.pendingCount !== b.pendingCount || a.rejectedCount !== b.rejectedCount;
    }
  }]);
}();
_ApprovalRequestStatus = ApprovalRequestStatus;
ApprovalRequestStatus.none = new _ApprovalRequestStatus(0, 0, 0);
export { ApprovalRequestStatus as default };
export function add(a, b) {
  return new ApprovalRequestStatus(a.pendingCount + b.pendingCount, a.approvedCount + b.approvedCount, a.rejectedCount + b.rejectedCount);
}
